import { Option, TeamRole } from 'app/types';
import asana from 'assets/svgs/ic_asana.svg';
import basecamp from 'assets/svgs/ic_basecamp.svg';
import excel from 'assets/svgs/ic_excel.svg';
import jira from 'assets/svgs/ic_jira.svg';
import monday from 'assets/svgs/ic_monday.svg';
import notion from 'assets/svgs/ic_notion.svg';
import trello from 'assets/svgs/ic_trello.svg';

export const toolPreferencesList = [
    {
        name: 'Basecamp',
        _id:'',
        src: basecamp
    }, 
    {
        name: 'Todolist',      
        _id:'',
        src: monday
    }, 
    {
        name: 'Monday',
        _id:'',
        src: monday
    }, 
    {
        name: 'Trello',
        _id:'',
        src: trello
    }, 
    {
        name: 'Jira',
        _id:'',
        src: jira
    }, 
    {
        name: 'Asana',
        _id:'',
        src: asana
    }, 
    {
        name: 'Wrike',
        _id:'',
        src: monday
    }, 
    {
        name: 'Notion',
        _id:'',
        src: notion
    }, 
    {
        name: 'Excel&CSV',
        _id:'',
        src: excel
    }, 
    {
        name: 'Confluence',
        _id:'',
        src: monday
    }
]

export const Roles: Option[] = [
    //disable due to confirmation 
    // {
    //     label: 'None', 
    //     value: TeamRole.NONE,
    //     description: ''
    // },
    {
        label: 'Team Owner',
        value: TeamRole.TEAM_OWNER,
        description: 'Has unrestricted access to all features, including billing and team deletion.'
    },
    {
        label: 'Administrator',
        value: TeamRole.ADMINISTRATOR,
        description: 'Has comprehensive control over all aspects of the system except billing and team deletion.'
    },
    {
        label: 'Project Manager',
        value: TeamRole.PROJECT_MANAGER,
        description: 'Oversees specific projects with full control, including access to team-wide timesheets, planning modules, and the ability to report time for all users.'
    },
    {
        label: 'Scrum Master',
        value: TeamRole.SCRUM_MASTER,
        description: 'Facilitates Agile processes with permissions to create sprints, access team-wide timesheets, and use planning modules.'
    },
    {
        label: 'Product Owner',
        value: TeamRole.PRODUCT_OWNER,
        description: 'Responsible for product backlog and roadmap planning. Has access to planning modules and team-wide archives.'
    },
    {
        label: 'Developer',
        value: TeamRole.DEVELOPER,
        description: 'Focuses on development tasks with permissions to update tasks and log time. '
    },
    {
        label: 'QA Tester',
        value: TeamRole.QA_TESTER,
        description: 'Specializes in quality assurance, with permissions similar to developers but focused on testing and bug reporting. '
    },
    {
        label: 'Designer',
        value: TeamRole.DESIGNER,
        description: 'Concentrates on design-related tasks, with access similar to developers but potentially with design-specific features.'
    },
    {
        label: 'Team Member',
        value: TeamRole.TEAM_MEMBER,
        description: 'Actively contributes to projects with full collaboration rights, including task management and communication.'
    },
    {
        label: 'Guest',
        value: TeamRole.GUEST_USER,
        description: 'Has limited access, typically restricted to specific projects or tasks, suitable for external collaborators.'
    },
    {
        label: 'Analyst',
        value: TeamRole.ANALYST,
        description: 'Focuses on reporting and insights, with access to project data, analytics, and performance tracking tools.'
    },
    {
        label: 'Customer Success Manager',
        value: TeamRole.CUSTOMER_SUCCESS_MANAGER,
        description: 'Oversees client relationships, ensuring satisfaction and engagement, with visibility into project progress and outcomes.'
    },
    {
        label: 'Stackholder',
        value: TeamRole.STAKEHOLDER,
        description: 'Monitors overall project status and results with high-level visibility, but with limited involvement in day-to-day tasks.'
    },
]